export const createDescriptorsGroupsRequests = (client) => ({
    listDescriptorsGroups: async (params) => {
        const { data, meta, links } = await client.api.get("descriptors_groups", {
            params: params,
        });
        return { data, meta, links };
    },
    createDescriptorsGroup: async (payload) => {
        const { data } = await client.api.create("descriptors_groups", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map